export default __webpack_public_path__ + "static/media/manage.746f350e.jpg";